import React, { isValidElement, Fragment } from "react";
import { Link as RouterLink } from "react-router-dom";

import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
// import ListItem from "../components/display/ListItem";

import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    border: "solid 1px red",
  },
  content: {
    display: "flex",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  leftBox: {
    width: 300,
    [theme.breakpoints.down("xs")]: {
      width: "unset",
    },
  },
  rightBox: {
    flex: 1,
  },
}));

const KeyValueText = ({ keyName, value, link, external }) => {
  const linkParams = external
    ? {
      target: "_blank",
      href: link,
    }
    : { component: RouterLink, to: link };
  const innerComponent = (
    <Fragment>
      {isValidElement(value) ? (
        <Box style={{ paddingTop: 5 }}>{value}</Box>
      ) : (
        <Typography variant="caption" style={{ fontSize: 13 }}>
          {`${value}`}
        </Typography>
      )}
    </Fragment>
  );

  return (
    <Box style={{ margin: 5 }}>
      <Typography variant="caption" color="textSecondary">
        {keyName}
      </Typography>
      <Divider light />
      <Box style={{ fontSize: 13, marginLeft: 10 }}>
        {value ? (
          link ? (
            <Link color="inherit" underline="none" {...linkParams}>
              {innerComponent}
            </Link>
          ) : (
            innerComponent
          )
        ) : (
          <Typography
            variant="caption"
            color="textSecondary"
            style={{ fontSize: 13 }}
          >
            {"-"}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default function FullWidthGrid() {
  const classes = useStyles();

  return (
    <div>
      <KeyValueText
        keyName="Name"
        link={"/home"}
        value="body2. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos
          blanditiis tenetur unde suscipit, quam beatae rerum inventore
          consectetur, neque doloribus, cupiditate numquam dignissimos laborum
          fugiat deleniti? Eum quasi quidem quibusdam."
      />
      <KeyValueText keyName="Age" value={5} />
      <KeyValueText keyName="Whatever" value="" />
      <KeyValueText
        keyName="Object"
        link={"https://www.google.com"}
        external
        value={<Paper className={classes.paper}>Footer</Paper>}
      />

      <Typography variant="caption">
        body2. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos
        blanditiis tenetur unde suscipit, quam beatae rerum inventore
        consectetur, neque doloribus, cupiditate numquam dignissimos laborum
        fugiat deleniti? Eum quasi quidem quibusdam.
      </Typography>
    </div>
    // <Box className={classes.root}>
    //   <Box>
    //     <Paper className={classes.paper}>Title</Paper>
    //   </Box>
    //   <Box className={classes.content}>
    //     <Box className={classes.leftBox}>
    //       <Paper className={classes.paper}>Left</Paper>
    //     </Box>
    //     <Box className={classes.rightBox}>
    //       <Paper className={classes.paper}>Right</Paper>
    //     </Box>
    //   </Box>
    //   <Box>
    //     <Paper className={classes.paper}>Footer</Paper>
    //   </Box>
    // </Box>
    // <ListItem
    //   header={<Paper className={classes.paper}>Title</Paper>}
    //   contentLeft={<Paper className={classes.paper}>Left</Paper>}
    //   contentRight={<Paper className={classes.paper}>Right</Paper>}
    //   footer={<Paper className={classes.paper}>Footer</Paper>}
    // />
  );
}
